import { useEffect, useState } from "react";
import { useAddAssignmentMarkMutation } from "../../../../../features/AssignmentMark/assignmentMarkApi";

export default function AssignmentModal({
  assignment,
  setIsModalOpen,
  loggedInUser,
  refetchStudentAssignment,
}) {
  const [assignmentRepo, setAssignmentRepo] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { title, totalMark, id } = assignment || {};

  const [addAssignmentMark, { isSuccess, isError, error }] =
    useAddAssignmentMarkMutation();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!assignmentRepo) {
      alert("Please enter your repo link");
      return;
    }

    const resultBody = {
      student_id: loggedInUser.student_id,
      student_name: loggedInUser.name,
      assignment_id: id,
      title,
      createdAt: new Date().toISOString(),
      totalMark,
      mark: 0,
      repo_link: assignmentRepo,
      status: "pending",
    };

    addAssignmentMark(resultBody);
  };

  useEffect(() => {
    if (isSuccess) {
      setIsModalOpen(false);
      setAssignmentRepo("");
      refetchStudentAssignment();
    } else if (isError) {
      setErrorMessage(error?.data);
    }
  }, [isSuccess, isError]);

  return (
    <>
      <div className="fixed z-10 inset-0 bg-gray-600 bg-opacity-50 "></div>
      <div className="fixed z-10 inset-0 overflow-y-auto ">
        <div className="flex items-center justify-center min-h-screen">
          <div className="bg-white rounded-lg shadow-lg p-6 w-2/4 max-w-md">
            <button
              className="text-black text-3xl ml-auto text-right w-full mb-2"
              type="button"
              onClick={() => setIsModalOpen(false)}
            >
              &times;
            </button>

            <div className="mb-4">
              <h1 className="text-xl font-bold text-gray-800">
                Assignment Details
              </h1>
            </div>
            <div className="mb-8">
              <p className="text-gray-700">
                <h2 className="font-bold">Assignment title:</h2>
                <p>{title}</p>

                <form onSubmit={handleSubmit}>
                  <div className="mt-4 mb-4">
                    {errorMessage && <p className="text-red-600">{error}</p>}

                    <label htmlFor="assignment_repo_link">
                      Assignment Repo Link
                    </label>
                    <input
                      id="assignment_repo_link"
                      name="assignment_repo_link"
                      type="text"
                      onChange={(e) => setAssignmentRepo(e.target.value)}
                      value={assignmentRepo}
                      required
                      className="border rounded-md w-full px-3 py-2 mt-1 text-gray-700 focus:outline-none focus:ring-2 focus:ring-cyan focus:border-transparent"
                      placeholder="Enter your assignment repo link"
                    />
                  </div>

                  <div className="text-right">
                    <button
                      type="submit"
                      className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm bg-cyan text-white"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
